import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-admin',
	templateUrl: './icon-admin.component.svg',
})
export class IconAdminComponent {}
